module.exports = __webpack_public_path__ + "static/media/LATINS-facade-avant.210d6e6e.jpg";